//TODO: Test replacing slick-carousel with something like the code below
//$(document).ready(function(){
//    $("#myCarousel").carousel();
//    if ( $(window).width() < 640 ) {
//        $('.col-sm-6').unwrap().addClass('item');
//        $('.col-sm-6:first').addClass('active');
//    }
//});

import 'slick-carousel/slick/slick.min.js';

$('section.s-slider-reviews .slider-slick').slick({
    infinite: false,
    slidesToShow: 3,
    // slidesToScroll: 3,
    dots: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                // slidesToScroll: 2,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                // slidesToScroll: 1,
            },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ],
});



// WEBPACK FOOTER //
// ./scripts/routes/sections/slider-reviews.js